var map = {
	"./0.png": 4563,
	"./1.png": 458,
	"./10.png": 5200,
	"./11.png": 3321,
	"./12.png": 8706,
	"./13.png": 3531,
	"./14.png": 9668,
	"./15.png": 3565,
	"./16.png": 9590,
	"./17.png": 6527,
	"./18.png": 6680,
	"./19.png": 545,
	"./2.png": 1569,
	"./3.png": 7704,
	"./4.png": 7319,
	"./5.png": 4830,
	"./6.png": 581,
	"./7.png": 8316,
	"./8.png": 4555,
	"./9.png": 3378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1272;